import { render, staticRenderFns } from "./LinkButtonDropdown.vue?vue&type=template&id=177c0ae5&"
import script from "./LinkButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./LinkButtonDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports